// Module Import
//---------------------------------
import React from 'react'
import styled from 'styled-components'
import { brandDarkGrey } from '../../../assets/consts/color'
import BreadcrumbWithMicroData from '../BreadcrumbWithMicrodata/BreadcrumbWithMicroData'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const BreadcrumbsWrapper = styled.div`
  min-height: 44px;

  font-size: 14px;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${brandDarkGrey};
  text-decoration: none;
  text-transform: capitalize;

  &:not(first-child) {
    text-transform: none;
  }

  @media only screen and (min-width: 48em) {
    min-height: 21px;
  }

  .breadcrumb__list {
    padding: 0;
    margin: 0 0 16px 0;
    justify-content: start;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    list-style: none;

    .breadcrumb__list__item {
      display: inline-block;
      /* white-space: nowrap; */
    }
  }
`
// Component Export
//---------------------------------
export default function Breadcrumbs(props) {
  return (
    <BreadcrumbsWrapper>
      <BreadcrumbWithMicroData {...props} />
    </BreadcrumbsWrapper>
  )
}
Breadcrumbs.propTypes = {}
